import { useToggle } from "./useToggle";

export const useFilter = () => {
  const { overlayState, toggleOverlay } = useToggle();

 
  const toggleFilter = () => {
    toggleOverlay('filter')
  };
  
  return { filterState: overlayState.filter, toggleFilter };
};